export default __webpack_public_path__ + "static/media/HDTX_Announcement of Extraordinary GMS 2025.a3e674c9.pdf";